<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'satisfactionSurvey'"
    class="page"
  >
    <Header
      :setting="{
        title: '滿意度調查',
        hasCancelMethod: ($route.params.isCloseToHome === 'y'),
      }"
      @cancel="$router.push('/home')"
      class="mb4"
    />
    <div class="page__form mt1 mb6">
      <input
        type="text"
        v-model="memberForm.bedNumber"
        placeholder="床號/Bed Number"
        class="mb5"
      >
      <input
        type="text"
        v-model="memberForm.name"
        placeholder="真實姓名/Real Name"
        class="mb5"
      >
      <input
        type="text"
        v-model="memberForm.attendingDoctor"
        placeholder="主治醫師/Attending Physician"
        class="mb5"
      >
      <input
        type="text"
        v-model="memberForm.dischargedDate"
        placeholder="出院日期/Discharged Date(YYYY/MM/DD)"
        class="mb5"
      >
    </div>
    <div class="page__text mb5">
      <div class="align--left ">
        以下滿意度調查
        <br> 5分 ➞ 非常滿意
        <br> 1分 ➞ 非常不滿意
      </div>
    </div>
    <div class="page__text">
      <template
        v-for="(contents,category) in surveyForm"
        :key="contents"
      >
        <div class="row--central mb3">
          <div class="label label--secondary fs1">
            {{ category }}
          </div>
        </div>
        <div
          v-for="(content,index) in contents"
          :key="content"
        >
          <Question
            v-if="content.type!=='questionGroup'&&content.type!=='recommend'"
            v-model:modelContent="surveyForm[category][index]"
          />
          <!-- 題組 -->
          <template v-else-if="content.type==='questionGroup'">
            <div class="align--left mb3">
              {{ content.question }}
            </div>
            <div
              v-if="content.skipReason!==null"
              class="row--start mb5"
            >
              <input
                type="checkbox"
                v-model="content.skipped"
                @change="
                  content.response=content.skipped?content.skipReason:null;
                  content.contents.forEach((detailContent)=>{
                    detailContent.response = null;
                  })"
                class="mt2"
              >
              <label class="ml2 align--left">
                {{ content.skipReason }}
              </label>
            </div>
            <template
              v-for="(detailContent,detailIndex) in content.contents"
              :key="detailContent"
            >
              <Question
                v-if="!content.skipped"
                v-model:modelContent="
                  surveyForm[category][index].contents[detailIndex]
                "
              />
            </template>
          </template>
          <!-- 是否推薦 -->
          <template v-else-if="content.type==='recommend'">
            <div class="align--left mb3">
              {{ content.question }}
            </div>
            <div class="row--start mb3">
              <div class="column--central">
                <input
                  type="radio"
                  v-model="content.response"
                  value="推薦"
                >
              </div>
              <label class="ml1">推薦</label>
            </div>
            <div class="row--start mb3">
              <div class="column--central">
                <input
                  type="radio"
                  v-model="content.response"
                  value="不推薦"
                >
              </div>
              <label class="ml1">不推薦</label>
            </div>
            <Question
              v-if="content.response==='不推薦'"
              v-model:modelContent="
                surveyForm[category][index].contents[0]
              "
            />
          </template>
        </div>
      </template>
    </div>
    <div
      @click="send"
      class="label label--primary mv3"
    >
      提交
    </div>
  </div>

  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
    @toHome="toHome"
    @toReview="toReview"
  />
</template>

<script>
import { onMounted, reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import composable from '@/composable/index';
import spiderman from '@/spiderman/index';
import api from '@/api/index';
import Question from './components/Question.vue';
import modelSurveyForm from './modelSurveyForm';

export default {
  components: { Question },
  setup() {
    const page = ref('satisfactionSurvey');
    const memberForm = reactive({
      bedNumber: '',
      name: '',
      attendingDoctor: '',
      dischargedDate: '',
    });
    const surveyForm = reactive(
      JSON.parse(
        JSON.stringify(modelSurveyForm),
      ),
    );
    const route = useRoute();
    const router = useRouter();

    onMounted(() => {
      memberForm.bedNumber = route.query.bedNumber;
      memberForm.name = route.query.name;
      memberForm.attendingDoctor = route.query.attendingDoctor;
      memberForm.dischargedDate = route.query.dischargedDate;
    });

    async function send() {
      try {
        composable.loading.show('傳送中，請稍候');

        spiderman.form.verify(memberForm);
        memberForm.dischargedDate = spiderman.moment(memberForm.dischargedDate)
          .format('YYYY-MM-DD');

        const isRecommend = surveyForm.其他.find((x) => x.type === 'recommend').response;
        if (isRecommend === null) {
          throw Error('請填寫23. 是否會向朋友推薦 本院');
        }

        if (isRecommend === '不推薦'
        && surveyForm.其他.find((x) => x.type === 'recommend').contents[0].response.trim() === '') {
          throw Error('請告訴我們 您不推薦的理由');
        }

        const postResponses = generatePostResponses();
        const survey = {
          ...memberForm,
          responses: postResponses,
        };

        await api.satisfactionSurveys.send(
          composable.member, survey,
        );

        if (isRecommend === '推薦') {
          composable.modal.show({
            body: '感謝您的填寫,是否前往Google評論?',
            hasCloseButton: false,
            footer: [
              { content: '返回主畫面', type: 'secondary', onClickEmit: 'toHome' },
              { content: '前往Google評論', type: 'primary', onClickEmit: 'toReview' },
            ],
          });
          return;
        }
        composable.modal.done('已送出,感謝您的填寫');
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    function generatePostResponses() {
      let responses = [];
      Object.values(surveyForm).forEach((responsesArray) => {
        responses = [...responses, ...responsesArray];
      });

      const postResponses = [];
      responses.forEach(({ question, response, contents }) => {
        postResponses.push({ question, response });

        if (contents !== undefined) {
          contents.forEach(
            ({ question: constentsQuestion, response: constentsResponse }) => {
              postResponses.push(
                { question: constentsQuestion, response: constentsResponse },
              );
            },
          );
        }
      });

      return postResponses;
    }

    function toHome() {
      composable.modal.close();
      router.push({ path: '/home' });
    }

    function toReview() {
      let cmd;
      if (composable.member.info.clinic === '璟馨') {
        cmd = spiderman.generate.specialCommand({
          cmd: 'browse',
          url: encodeURI('https://search.google.com/local/writereview?placeid=ChIJkcWeeSZ3bjQRlnOa5FVjBig'),
          timestamp: spiderman.generate.timestamp(),
        });
      }
      if (composable.member.info.clinic === '詠馨') {
        cmd = spiderman.generate.specialCommand({
          cmd: 'browse',
          url: encodeURI('https://search.google.com/local/writereview?placeid=ChIJQZR4aFl2bjQRgWvdOys_tGQ'),
          timestamp: spiderman.generate.timestamp(),
        });
      }
      router.replace(`${route.path}#inncom#${cmd}`);
    }

    return {
      page,
      composable,
      memberForm,
      surveyForm,
      send,
      toHome,
      toReview,
    };
  },
};
</script>
